//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AudioAnalysis from './_audio_analysis'
export default {
    components: {
        AudioAnalysis
    },
    props: {
        playing: Boolean,
        url: Object,
        type: String,
        floor: Boolean,
        price: Boolean
    },
    methods: {
        goVideo () {
            this.$emit('goVideo')
        },
        openVr () {
            this.$emit('openVr')
        },
        goLayout() {
            this.$emit('goLayout', this.url.id)
        },
        goPrice() {
            this.$emit('goPrice')
        }
    }
}
